export default __webpack_public_path__ + "static/media/863.bf045d68.gif";